import { render, staticRenderFns } from "./oneFaq.vue?vue&type=template&id=d9995978&scoped=true&"
import script from "./oneFaq.vue?vue&type=script&lang=js&"
export * from "./oneFaq.vue?vue&type=script&lang=js&"
import style0 from "./oneFaq.vue?vue&type=style&index=0&id=d9995978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9995978",
  null
  
)

export default component.exports